/**
 * Shopify WebView Detection and Element Hiding
 * Detects if the page is loaded within a mobile app WebView via cookie
 * and hides specified Shopify elements accordingly
 */

function getCookieValue(name) {
    const regex = new RegExp(`(^| )${name}=([^;]+)`)
    const match = document.cookie.match(regex)
    if (match) {
        return match[2]
    }
}

/**
 * Hide elements when running inside WebView
 */
function hideElementsForWebView() {
    // Common Shopify selectors for elements to hide in WebView
    const elementsToHide = [
        'header',
        'footer'
        // Add more selectors specific to your theme
    ];

    elementsToHide.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            element.style.display = 'none';
        });
    });
}

/**
 * Main function to check for WebView and apply changes
 */
function initWebViewDetection() {
    // Check for the specific cookie that indicates WebView
    const webViewCookie = getCookieValue('napps_mobile');
    
    if (webViewCookie == 1) {
        console.log('WebView detected in Shopify - hiding elements');
        hideElementsForWebView();
    }
}

// For Shopify, we need to handle both immediate execution and theme loading
function runWebViewDetection() {
    initWebViewDetection();
}

// Run immediately
runWebViewDetection();

// Run after Shopify theme is loaded (some themes load content dynamically)
window.addEventListener('load', runWebViewDetection);
